
  import {Component, Prop, Vue} from "vue-property-decorator";
  import VoucherService from "../../../services/voucher.service"
  import LoadingOverlay from "../../core/LoadingOverlay.vue";
  import {Voucher} from "../../../models/voucherI";

  @Component({
    components: {LoadingOverlay},
  })
  export default class ApproveDialog extends Vue {

    @Prop({default: null})
    voucher: any;

    private declineReason = "";
    
    private showOverlay = false;

    private maxTwoHundred =  [
      (v: string) => !!v || 'Feld muss ausgefüllt sein',
      (v: string) => /^.{0,200}$/.test(v) || 'Maximal '+ 200 + ' Zeichen'
    ];

    declineVoucher() {
      this.showOverlay = true;

      let data = {
        voucherId: this.voucher.id,
        declineReason: this.declineReason
      }

      VoucherService.declineVoucher(data)
        .then(
          (response: any) => {
            this.$notify({
              group: 'foo',
              title: 'Info',
              text: response.data,
              type: 'success'
            });
            this.showOverlay = false;
            (this.$refs.form as Vue & { reset: () => boolean }).reset();
            this.$emit('event');
          })
        .catch((error: any) => {
          this.$notify({
            group: 'foo',
            title: 'Fehler',
            text: error.response.data,
            type: 'error'
          });
          this.showOverlay = false;
        })
        .finally(() => {
          setTimeout(() => {
            this.showOverlay = false;
          }, 5000);
        });
    }

  }
